import * as React from "react";

export class FormsColumn extends React.Component<FormsColumnProps, FormsColumnState> {
    static defaultProps: Partial<FormsColumnProps> = {};

    constructor(props: FormsColumnProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <td style={{width:this.props.Column.Width+'%'}}>
                {this.GenerateColumnContent()}
            </td>
        )
    }

    public MaybeGetValue<T>(obj:T,propertyName:keyof T,defaultValue:any)
    {
        if(obj[propertyName]==null)
            return defaultValue;

        return obj[propertyName];
    }

    public MaybeGetColumnProperty<T>(property:keyof FormColumn,defaultValue:T):T
    {
        return this.MaybeGetValue(this.props.Column,property,defaultValue);

    }

    public GetRowValue(property='')
    {
        if(property=='')
            property=this.MaybeGetColumnProperty('Property','');
        return this.MaybeGetValue(this.props.Data,property,'');
    }

    public SetRowValue(value,property='')
    {
        if(property=='')
            property=this.MaybeGetColumnProperty('Property','');

        if(property=='')
            throw Error('Property can not be empty');

        this.props.Data[property]=value;
        this.forceUpdate();
    }


    private GenerateColumnContent() {
        let type=this.MaybeGetColumnProperty('Type','String');
        switch (type)
        {
            case 'String':
                return this.GetStringColumn();
            case 'Number':
                return this.GetNumberColumn();
        }
    }

    private GetStringColumn() {

        let property=this.GetRowValue('Property')
        return <input type={'text'}
                      readOnly={this.MaybeGetColumnProperty('ReadOnly',false)}
                      value={this.GetRowValue(property)} onChange={x=>this.SetRowValue(x.target.value)} />
    }

    private GetNumberColumn() {

        let property=this.GetRowValue('Property')
        return <input type={'number'} style={{textAlign:'right',WebkitAppearance:'none'}}
                      readOnly={this.MaybeGetColumnProperty('ReadOnly',false)}
                      value={this.GetRowValue(property)} onChange={x=>this.SetRowValue(x.target.value)} />
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FormsColumnProps {
    Column:FormColumn;
    Data:any;
}

interface FormsColumnState {

}

//#endregion "My Region"